import {Collection} from "vue-mc"
import policyDocumentsModel from "@/models/policyDocumentsModel"

import Vue from "vue";

export default class policyDocumentsCollection extends Collection {

	model() {
		return policyDocumentsModel;
	}

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'list',
			dbData: {}
		}
	}

	options() {
		return {
			methods: {
				list: 'GET'
			}
		}
	}

	routes() {
		return {
			list: 'interpreter/policyDocument/list'
		}
	}

	requestRoute() {

		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.getAttributes().methodTypes);
		let route = this.getAttributes().inBuiltApi + this.getRoute(this.getAttributes().methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);

		// console.log(headers, method, url, data);

		return this.getRequest({headers, method, url}).send();
	}

	getList() {
		return this.requestRoute();
	}
}
